import React, { useMemo } from 'react';
import yn from 'yn';
import { Space } from 'antd-v5';
import { connect } from 'react-redux';
import { PRODUCT_DETAILS_SECTIONS } from './constants';
import formatToCurrency from '../../../../../../../utils/formatToCurrency';
import './styles.css';

const formatString = value => {
  return (value || '').trim();
};

const filterSectionItems = (section, product, role) => {
  return section.items.map(item => {
    if (item.roles && !item.roles.includes(role)) {
      return null;
    }

    const value =
      section.itemType === 'number' ? formatToCurrency(`${product[item.key]}`) : formatString(product[item.key]);

    if (!value) return null;

    return [item.label, value];
  });
};

const ProductDetailsContent = ({ product, role, merchantConfig }) => {
  const sectionHasItems = section => {
    return section.itemType === 'number' || section.items.some(item => Boolean(product[item.key]));
  };

  const productName = useMemo(
    () => product.name ?? product.description ?? product.fileName ?? '',
    [product.description, product.fileName, product.name]
  );

  const price = useMemo(() => {
    const value = product.vendorId ? product.msrp : product.price;

    return formatToCurrency(`${value}`);
  }, [product.price, product.vendorId, product.msrp]);

  return (
    <div className="clients-v2-collection-product-details">
      <h1 className="clients-v2-collection-product-details--name">{productName}</h1>
      {product.type !== "attachment" &&
        <>
          <h2 className="clients-v2-collection-product-details--sku">{product.sku}</h2>

          {(yn(merchantConfig.HIDE_PRODUCT_COST) && role === 'ASSOCIATE') || (
            <h3 className="clients-v2-collection-product-details--price">{price}</h3>
          )}

          <hr />

          <section>
            <p>{(product.description || '').replace(/<[^>]*>/g, '').trim() || 'No Description'}</p>
          </section>

          <section>
            {PRODUCT_DETAILS_SECTIONS.map(section => {
              if (
                sectionHasItems(section) && section.config
                  ? yn(merchantConfig[section.config?.name]) === section.config?.value ||
                  section.config?.roles.includes(role)
                  : true
              ) {
                const filteredItems = filterSectionItems(section, product, role);

                if (filteredItems.every(item => item === null)) {
                  return null;
                }

                return (
                  <div key={section.label}>
                    <h2 className="clients-v2-collection-product-details--title">{section.label}</h2>

                    <div className="clients-v2-collection-product-details--section">
                      {filteredItems
                        .filter(item => Array.isArray(item))
                        .map(item => (
                          <div key={`${item[0]}-${item[1]}`} >
                            <Space >
                              <span >{item[0]}</span>
                              <span >{item[1]}</span>
                            </Space >
                          </div>
                        ))}


                    </div>
                  </div>
                );
              }

              return null;
            })}
          </section>
        </>}
    </div>
  );
};

const mapStateToProps = state => ({
  role: state.auth.role,
  merchantConfig: state.auth.merchantConfig,
});

export default connect(mapStateToProps, {})(ProductDetailsContent);
